export const VERSION = '2.45.2';
